export const PIN_TO_HOMEPAGE = 'PIN_TO_HOMEPAGE';
export const GET_PIN_TO_HOMEPAGE = 'GET_PIN_TO_HOMEPAGE';
export const DELETE_FROM_HOMEPAGE = 'DELETE_FROM_HOMEPAGE';
export const SET_SIGNWORKFLOWS_VUE_ORDER = 'SET_SIGNWORKFLOWS_VUE_ORDER';
export const SET_SOCIAL_SIGNATORIES_VUE_ORDER = 'SET_SOCIAL_SIGNATORIES_VUE_ORDER';
